"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinearProgress = void 0;
const React = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const LinearProgressContainer = Theme_1.styled.div `
  position: relative;
  overflow: hidden;
  height: 2px;
  width: 100%;
`;
const LinearProgressBar1 = Theme_1.styled.div `
  background-color: ${(props) => props.theme.blue};
  transition: transform 0.2s linear;
  transform-origin: left;
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  width: auto;
  animation: animate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;

  @keyframes animate1 {
    0% {
      left: -35%;
      right: 100%;
    }
    60% {
      left: 100%;
      right: -90%;
    }
    100% {
      left: 100%;
      right: -90%;
    }
  } ;
`;
const LinearProgressBar2 = Theme_1.styled.div `
  background-color: ${(props) => props.theme.blue};
  width: auto;
  transition: transform 0.2s linear;
  transform-origin: left;
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  animation: animate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
  animation-delay: 0.5s;

  @keyframes animate2 {
    0% {
      left: -200%;
      right: 100%;
    }
    60% {
      left: 107%;
      right: -8%;
    }
    100% {
      left: 107%;
      right: -8%;
    }
  } ;
`;
exports.LinearProgress = () => {
    return (React.createElement(LinearProgressContainer, null,
        React.createElement(LinearProgressBar1, null),
        React.createElement(LinearProgressBar2, null)));
};
//# sourceMappingURL=LinearProgress.js.map